import React from 'react';
import {View} from 'react-native';
import {get} from 'lodash';

import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {REPORT_CLOSE_TO_FIBC_RANK} from '/enum/records.enum';
import {withTranslation} from '/provider/TranslationProvider';

import CloseToRankReportContent from '../CloseToRankReportContent';

import {styles} from './CloseToFibcReportContent.style';

interface CloseToFibcReportContentProps {
  tt: (key: string, defaultText?: string) => string;
  recordData: Record<string, any>;
}

export const CloseToFibcReportContent = ({
  tt = (key, defaultText) => defaultText || key,
  recordData = {},
}: CloseToFibcReportContentProps) => {
  const rankProgression = get(recordData, '__extras.rankProgression', {});

  return (
    <View>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading">{tt('title', 'Close To FIBC')}</Text>
        </Gutter>
      </View>
      <CloseToRankReportContent
        progressionData={rankProgression}
        report={REPORT_CLOSE_TO_FIBC_RANK}
      />
    </View>
  );
};

export default withTranslation('reportCardContent.closeToFibc')(
  CloseToFibcReportContent,
);
